import { createFileRoute, Link, useSearch } from "@tanstack/react-router";
import { AlertCircle } from "lucide-react";
import { z } from "zod";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const SearchSchema = z.object({
  reason: z.string().optional(),
});

export const Route = createFileRoute("/_authenticated/create/failed")({
  head: () => ({
    meta: [
      { title: "生成エラー | KAGEM" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  validateSearch: (s) => SearchSchema.parse(s),
  component: FailedPage,
});

function FailedPage() {
  const { reason } = useSearch({ from: "/_authenticated/create/failed" });
  return (
    <main className="min-h-screen bg-background px-4 py-10">
      <div className="mx-auto max-w-xl">
        <Card className="p-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10">
            <AlertCircle className="h-7 w-7 text-destructive" />
          </div>
          <h1 className="text-2xl font-bold">生成に失敗しました</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            消費したクレジットは自動的に返却されます。
          </p>
          {reason && (
            <div className="mt-4 rounded-md border border-destructive/30 bg-destructive/5 p-3 text-left text-xs text-destructive">
              {reason}
            </div>
          )}
          <div className="mt-6 flex flex-col items-stretch gap-2 sm:flex-row sm:justify-center">
            <Button asChild>
              <Link to="/create">もう一度試す</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/dashboard">ダッシュボードへ</Link>
            </Button>
          </div>
        </Card>
      </div>
    </main>
  );
}
